import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-arrow-right",
  "use": "icon-s-arrow-right-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-arrow-right\"><path fill-rule=\"evenodd\" d=\"M14.0280466 3 22 11.0089749 14.0280466 18.9994391 12.7076146 17.6604964 18.4366849 11.928341 0 11.928341.0370214556 10.0865236 18.4366849 10.0865236 12.7076146 4.33894264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol